<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_compensatoryleave" transform="translate(1548 2999)">
      <path
        id="패스_4050"
        data-name="패스 4050"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(-1548 -2999)"
      />
      <g id="그룹_8351" data-name="그룹 8351">
        <path
          id="빼기_2"
          data-name="빼기 2"
          class="cls-2"
          fill="#087ef7"
          d="M21,16H5a2,2,0,0,1-2-2V11A3,3,0,1,0,3,5V2A2,2,0,0,1,5,0H21a2,2,0,0,1,2,2V5a3,3,0,1,0,0,6v3A2,2,0,0,1,21,16Z"
          transform="translate(-1549 -2995)"
        />
        <g id="local_activity_black_24dp" transform="translate(-1548 -2999)">
          <path
            id="패스_3949"
            data-name="패스 3949"
            class="cls-3"
            fill="#ffc304"
            d="M9.07,16,12,14.12,14.93,16l-.89-3.36,2.69-2.2-3.47-.21L12,7l-1.27,3.22-3.47.21,2.69,2.2Z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
